<template>
	<div class="setting" v-show="show">
		<div class="setting__label">{{$t(item.name)}}</div>
		<div id="res-air-temp" class="setting__option">
			<input id="ref-set-flow" type="number" min="0" max="30" :value="item.value | RounderOut" step=".1" readonly="readonly" @focus.prevent="$event.target.blur()">
		</div>
		<div class="setting__option setting__unit">{{$t(converterType)}}</div>
	</div>
</template>

<script>

import converter from './../../convert.service'

export default {
	name: 'outputComponent',
	props: ['item', 'index', 'inputType'],
	data() {
		return {
			title: null,
			prevIndex: null,
			show : true
		}
	},
	methods: {
		selectItem() {
			//this.tech.selected = !this.tech.selected;
			this.$emit('unit-clicked', this);
		}
	},
	computed: {
		converterType() {
			const param = this.$store.state.settings[this.item.inputParam];
			//console.log(this.item.inputParam + ' from:' + this.prevIndex + ' to:' + param.selected);
			//convert item.value
			if (this.prevIndex !== undefined) {
				switch (this.item.inputParam) {
					case 'CompressedAirFlow':
						this.item.value = converter.Flow(this.prevIndex, param.selected, this.item.value);
						break;
					case 'Temperature':
						if(this.inputType === 'Coolant') 
							this.show = (this.$store.state.settings.CoolingWaterInput.selected === 0) ? true : false;
						
						this.item.value = converter.Temperature(this.prevIndex, param.selected, this.item.value);
						break;
					case 'Pressure':
						this.item.value = converter.Pressure(this.prevIndex, param.selected, this.item.value);
						break;
					case 'CoolingWaterflow':
						this.show = (this.$store.state.settings.CoolingWaterInput.selected === 1) ? true : false;

					
						this.item.value = converter.CoolingWaterFlow(this.prevIndex, param.selected, this.item.value);
						break;
				}
			}

			


			this.prevIndex = param.selected;
			const converterAddon = (this.item.inputParam === 'Pressure' && param.selected === 0) ? "(g)" : '';
			return param.items[param.selected].name + converterAddon;
		}
	},
	mounted: function() {
		this.$nextTick(function() {
			//this.iTitle = (this.displayUnit) ? this.tech.type : this.tech.title;
		});
	}
}
</script>

<style lang="css" >

</style>


// WEBPACK FOOTER //
// SettingOuput.vue?0bb097c2